import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { SwiperOptions } from 'swiper/types/swiper-options';

import { EInfoType } from 'src/app/core/enums/country-info-type.enum';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { CityListMobileComponent } from '../city-list-mobile/city-list-mobile.component';
import { RegionCardMobileComponent } from '../region-card-mobile/region-card-mobile.component';

const REGION_LIST_SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 1.2,
  spaceBetween: 16,
  autoplay: {
    delay: 7000,
  },
  breakpoints: {
    375: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    524: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    1100: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
};

@Component({
  selector: 'app-region-list-mobile',
  templateUrl: './region-list-mobile.component.html',
  styleUrls: ['region-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    SwiperDirective,
    RegionCardMobileComponent,
    CityListMobileComponent,
    LocationListModule,
  ],
})
export class RegionListMobileComponent implements OnChanges {
  @Input() isFetching: boolean = false;
  @Input() countryName: string = '';
  @Input() regions: any[] = [];
  @Input() selectedRegionId: string = '';

  protected readonly swiperOptions: SwiperOptions = REGION_LIST_SWIPER_OPTIONS;
  protected readonly eInfoType = EInfoType;
  protected readonly visibleCities: Set<any> = new Set();

  ngOnChanges() {
    if (this.regions.length && this.selectedRegionId) {
      if (this.selectedRegionId) {
        this.handleShowCities(this.selectedRegionId);
      }
    }
  }

  handleShowCities(regionId: string): void {
    const region = this.regions.find((r) => r?.place_id === regionId);
    if (region) {
      this.visibleCities.add(region);
    }
  }

  handleHideCities(regionId: string): void {
    const region = Array.from(this.visibleCities).find(
      (r) => r?.place_id === regionId,
    );
    if (region) {
      this.visibleCities.delete(region);
    }
  }
}
